import React from 'react';

// FRONT / BACK ADS chip — ONE definition for every surface that shows a P2P
// platform order (Platform Orders list, Pending Tasks, Task Tracking).
// Operator 2026-10-09: a back-ads order "wasn't shown as back ads on pending
// task and task tracking, thus finance have no idea it's a back ads order
// unless the finance clicked into order history". Back ads = the platform
// price is not the real one (a verbally agreed price applies), so finance
// must see it on the task itself. Renders nothing for legacy orders (NULL).
export default function AdsTypeChip({ adsType, style }) {
  if (adsType !== 'front' && adsType !== 'back') return null;
  const back = adsType === 'back';
  return (
    <span
      title={back ? 'Back Ads: the platform price is not the real one — a verbally agreed price applies' : 'Front Ads: a normal ad at the real platform price'}
      style={{
        fontSize: 'max(10px, 0.68rem)',
        fontWeight: 600,
        padding: '1px 6px',
        borderRadius: '8px',
        whiteSpace: 'nowrap',
        background: back ? '#fef3c7' : '#e0e7ff',
        color: back ? '#92400e' : '#3730a3',
        ...(style || {}),
      }}
    >
      {back ? 'BACK ADS' : 'FRONT ADS'}
    </span>
  );
}
